"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NitriteReducingBacteria = void 0;
const Tags_1 = require("../Tags");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const OrOptions_1 = require("../../inputs/OrOptions");
const ResourceType_1 = require("../../ResourceType");
const SelectOption_1 = require("../../inputs/SelectOption");
const CardName_1 = require("../../CardName");
const LogHelper_1 = require("../../LogHelper");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const constants_1 = require("../../constants");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
const CardRenderer_1 = require("../render/CardRenderer");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const Units_1 = require("../../Units");
class NitriteReducingBacteria extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.NITRITE_REDUCING_BACTERIA,
            tags: [Tags_1.Tags.MICROBE],
            cost: 11,
            resourceType: ResourceType_1.ResourceType.MICROBE,
            metadata: {
                cardNumber: '157',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('Add 1 Microbe to this card.', (eb) => {
                        eb.empty().startAction.microbes(1);
                    }).br;
                    b.or().br;
                    b.action('Remove 3 Microbes to increase your TR 1 step.', (eb) => {
                        eb.microbes(3).startAction.tr(1);
                    }).br;
                    b.microbes(3);
                }),
                description: 'Add 3 Microbes to this card.',
            },
        });
        this.resourceCount = 0;
    }
    play(player) {
        player.game.defer(new DeferredAction_1.DeferredAction(player, () => {
            player.addResourceTo(this, { qty: 3, log: true });
            return undefined;
        }));
        return undefined;
    }
    canAct(player) {
        const redsAreRuling = PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS);
        const trGain = 1;
        if (this.resourceCount >= 3)
            Card_1.Card.setRedsActionWarningText(player, trGain, this, redsAreRuling, 'raise TR');
        if (redsAreRuling && this.reserveUnits.megacredits < trGain * constants_1.REDS_RULING_POLICY_COST) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails();
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
        }
        return true;
    }
    action(player) {
        if (this.resourceCount < 3) {
            player.addResourceTo(this, { log: true });
            return undefined;
        }
        const orOptions = new OrOptions_1.OrOptions();
        const redsAreRuling = PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS);
        if (!redsAreRuling || (redsAreRuling && player.canAfford(this.reserveUnits.megacredits))) {
            orOptions.options.push(new SelectOption_1.SelectOption('Remove 3 microbes to increase your terraform rating 1 step', 'Remove microbes', () => {
                player.removeResourceFrom(this, 3);
                LogHelper_1.LogHelper.logRemoveResource(player, this, 3, 'gain 1 TR');
                player.increaseTerraformRatingSteps(1);
                return undefined;
            }));
        }
        orOptions.options.push(new SelectOption_1.SelectOption('Add 1 microbe to this card', 'Add microbe', () => {
            player.addResourceTo(this, { log: true });
            return undefined;
        }));
        if (orOptions.options.length === 1)
            return orOptions.options[0].cb();
        return orOptions;
    }
    getActionDetails() {
        return new RedsPolicy_1.ActionDetails({ TRIncrease: 1 });
    }
}
exports.NitriteReducingBacteria = NitriteReducingBacteria;
//# sourceMappingURL=NitriteReducingBacteria.js.map